import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buyerMutationApi } from "@/shared/api/buyer/mutation";
import { BUYER_QUERY_KEY } from "@/shared/api/buyer/query";
import { BuyerUpdateRequestBody } from "@/shared/api/buyer/types";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

// 바이어 정보 수정 — 보낸 필드만 갱신되므로 호출부는 고친 값만 담아 넘긴다.
// 성공 안내 UI는 호출부가 담당한다.
const useUpdateBuyer = () => {
  const { companyId } = useCompanyIdentity();
  const queryClient = useQueryClient();
  const { error } = useAppToasts({ id: "GLOBAL" });

  return useMutation({
    mutationFn: (body: BuyerUpdateRequestBody) =>
      buyerMutationApi.updateBuyer(companyId as number, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: BUYER_QUERY_KEY(companyId) });
    },
    onError: (err) => {
      error(err);
    },
  });
};

export default useUpdateBuyer;
